import React from "react";
import * as S from '../../../styles/core-styles/AdminTools-styles';

export default function UserManagementMenu(props) {

  const { changePassword, showUserManagementMenu, logout, showUserSettings, user } = props;
  
  function handlePasswordClick(){
    changePassword();
    showUserManagementMenu();
  };

  return (
    <S.UserManagementMenuContainer>
      <S.ManagementMenuTitle>User Management</S.ManagementMenuTitle>
      <S.ManagementMenuLoggedInUser>{user.email}</S.ManagementMenuLoggedInUser>
      <S.ManagementMenuSeparator />
      <S.ManagementMenuList>
        <S.ManagementMenuItem onClick={showUserSettings}>
          User Settings
        </S.ManagementMenuItem>
        <S.ManagementMenuItem onClick={handlePasswordClick}>
          Change Password
        </S.ManagementMenuItem>
        <S.ManagementMenuItem onClick={logout}>
          Logout
        </S.ManagementMenuItem>
      </S.ManagementMenuList>
    </S.UserManagementMenuContainer>
  );
}
